import { ReactNode } from "react";
import { Paper, PaperProps } from "@mui/material";
import { createUseStyles } from "react-jss";
import { theme } from "$utils/theme/bataillog";

type Props = {
  children: ReactNode;
  isReadOnly: boolean;
} & PaperProps;

function ReferencingBlock({ children, isReadOnly, ...paperProps }: Props) {
  const classes = useStyles({ isReadOnly });
  return (
    <Paper variant="outlined" className={classes.wrapper} {...paperProps}>
      {children}
    </Paper>
  );
}

const useStyles = createUseStyles(() => ({
  wrapper: {
    background: (props: { isReadOnly: boolean }) =>
      props.isReadOnly ? `${theme.color.gray1} !important` : "",
    border: (props: { isReadOnly: boolean }) =>
      !props.isReadOnly ? `3px solid ${theme.color.blueLight} !important` : "",
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    position: "relative",
  },
}));

export default ReferencingBlock;
